import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { addDisposer, types, cast, getEnv, getSnapshot } from 'mobx-state-tree';
import clone from 'clone';
import { autorun } from 'mobx';
import { getConf, readConfObject } from '@jbrowse/core/configuration';
import { linearWiggleDisplayModelFactory } from '@jbrowse/plugin-wiggle';
import { getContainingView } from '@jbrowse/core/util';
// locals
import Tooltip from '../components/Tooltip';
import { FilterModel, getUniqueModificationValues } from '../../shared';
// using a map because it preserves order
var rendererTypes = new Map([['snpcoverage', 'SNPCoverageRenderer']]);
/**
 * #stateModel LinearSNPCoverageDisplay
 * extends `LinearWiggleDisplay`
 */
function stateModelFactory(pluginManager, configSchema) {
  return types.compose('LinearSNPCoverageDisplay', linearWiggleDisplayModelFactory(pluginManager, configSchema), types.model({
    /**
     * #property
     */
    type: types.literal('LinearSNPCoverageDisplay'),
    /**
     * #property
     */
    drawInterbaseCounts: types.maybe(types.boolean),
    /**
     * #property
     */
    drawIndicators: types.maybe(types.boolean),
    /**
     * #property
     */
    drawArcs: types.maybe(types.boolean),
    /**
     * #property
     */
    filterBy: types.optional(FilterModel, {}),
    /**
     * #property
     */
    colorBy: types.maybe(types.model({
      type: types.string,
      tag: types.maybe(types.string)
    }))
  })).volatile(function () {
    return {
      modificationTagMap: undefined
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setConfig: function setConfig(configuration) {
        self.configuration = configuration;
      },
      /**
       * #action
       */
      setFilterBy: function setFilterBy(filter) {
        self.filterBy = cast(filter);
      },
      /**
       * #action
       */
      setColorBy: function setColorBy(colorBy) {
        self.colorBy = cast(colorBy);
      },
      /**
       * #action
       */
      updateModificationColorMap: function updateModificationColorMap(uniqueModifications) {
        var colorPalette = ['red', 'blue', 'green', 'orange', 'purple'];
        var i = 0;
        var newMap = clone(self.modificationTagMap) || {};
        uniqueModifications.forEach(function (value) {
          if (!newMap[value]) {
            var newColor = colorPalette[i++];
            newMap[value] = newColor;
          }
        });
        self.modificationTagMap = newMap;
      }
    };
  }).views(function (self) {
    var superRenderProps = self.renderProps;
    return {
      /**
       * #getter
       */
      get rendererConfig() {
        var _a, _b, _c;
        var configBlob = getConf(self, ['renderers', self.rendererTypeName]) || {};
        return self.rendererType.configSchema.create(_objectSpread({}, configBlob, {
          drawInterbaseCounts: (_a = self.drawInterbaseCounts) !== null && _a !== void 0 ? _a : configBlob.drawInterbaseCounts,
          drawIndicators: (_b = self.drawIndicators) !== null && _b !== void 0 ? _b : configBlob.drawIndicators,
          drawArcs: (_c = self.drawArcs) !== null && _c !== void 0 ? _c : configBlob.drawArcs
        }), getEnv(self));
      },
      /**
       * #getter
       */
      get drawArcsSetting() {
        var _a;
        return (_a = self.drawArcs) !== null && _a !== void 0 ? _a : readConfObject(this.rendererConfig, 'drawArcs');
      },
      /**
       * #getter
       */
      get drawInterbaseCountsSetting() {
        var _a;
        return (_a = self.drawInterbaseCounts) !== null && _a !== void 0 ? _a : readConfObject(this.rendererConfig, 'drawInterbaseCounts');
      },
      /**
       * #getter
       */
      get drawIndicatorsSetting() {
        var _a;
        return (_a = self.drawIndicators) !== null && _a !== void 0 ? _a : readConfObject(this.rendererConfig, 'drawIndicators');
      },
      /**
       * #getter
       */
      get modificationsReady() {
        var _a;
        return ((_a = self.colorBy) === null || _a === void 0 ? void 0 : _a.type) === 'modifications' ? self.modificationTagMap !== undefined : true;
      },
      /**
       * #method
       */
      renderProps: function renderProps() {
        var superProps = superRenderProps();
        var colorBy = self.colorBy,
          filterBy = self.filterBy,
          modificationTagMap = self.modificationTagMap;
        return _objectSpread({}, superProps, {
          notReady: superProps.notReady || !this.modificationsReady,
          modificationTagMap: modificationTagMap,
          // must use getSnapshot because otherwise changes to e.g. just the
          // colorBy.type are not read
          colorBy: colorBy ? getSnapshot(colorBy) : undefined,
          filterBy: filterBy ? getSnapshot(filterBy) : undefined
        });
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      toggleDrawIndicators: function toggleDrawIndicators() {
        self.drawIndicators = !self.drawIndicatorsSetting;
      },
      /**
       * #action
       */
      toggleDrawInterbaseCounts: function toggleDrawInterbaseCounts() {
        self.drawInterbaseCounts = !self.drawInterbaseCountsSetting;
      },
      /**
       * #action
       */
      toggleDrawArcs: function toggleDrawArcs() {
        self.drawArcs = !self.drawArcsSetting;
      },
      afterAttach: function afterAttach() {
        addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var colorBy, view, staticBlocks, adapter;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                colorBy = self.colorBy;
                view = getContainingView(self);
                if (!(!view.initialized || !self.estimatedStatsReady || self.regionTooLarge)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                staticBlocks = view.staticBlocks;
                if (!((colorBy === null || colorBy === void 0 ? void 0 : colorBy.type) === 'modifications')) {
                  _context.next = 13;
                  break;
                }
                adapter = getConf(self.parentTrack, 'adapter');
                _context.t0 = self;
                _context.next = 11;
                return getUniqueModificationValues(self, adapter, colorBy, staticBlocks);
              case 11:
                _context.t1 = _context.sent;
                _context.t0.updateModificationColorMap.call(_context.t0, _context.t1);
              case 13:
                _context.next = 19;
                break;
              case 15:
                _context.prev = 15;
                _context.t2 = _context["catch"](0);
                console.error(_context.t2);
                self.setError(_context.t2);
              case 19:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 15]]);
        })), {
          delay: 1000
        }));
      }
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems;
    return {
      /**
       * #getter
       */
      get TooltipComponent() {
        return Tooltip;
      },
      /**
       * #getter
       */
      get adapterConfig() {
        var subadapter = getConf(self.parentTrack, 'adapter');
        return {
          type: 'SNPCoverageAdapter',
          subadapter: subadapter
        };
      },
      /**
       * #getter
       */
      get rendererTypeName() {
        return rendererTypes.get('snpcoverage');
      },
      /**
       * #getter
       */
      get needsScalebar() {
        return true;
      },
      /**
       * #method
       */
      contextMenuItems: function contextMenuItems() {
        return [];
      },
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [].concat(_toConsumableArray(superTrackMenuItems()), [{
          label: 'Draw insertion/clipping indicators',
          type: 'checkbox',
          checked: self.drawIndicatorsSetting,
          onClick: function onClick() {
            return self.toggleDrawIndicators();
          }
        }, {
          label: 'Draw insertion/clipping counts',
          type: 'checkbox',
          checked: self.drawInterbaseCountsSetting,
          onClick: function onClick() {
            return self.toggleDrawInterbaseCounts();
          }
        }, {
          label: 'Draw arcs',
          type: 'checkbox',
          checked: self.drawArcsSetting,
          onClick: function onClick() {
            return self.toggleDrawArcs();
          }
        }]);
      }
    };
  });
}
export default stateModelFactory;